import React, { createContext, useContext } from 'react';
import { useUnreadMessages as useUnreadMessagesHook } from '../hooks/useUnreadMessages';

interface UnreadMessagesContextType {
  hasUnreadMessages: boolean;
  unreadCount: number;
  markAsRead: () => void;
}

export const UnreadMessagesContext = createContext<UnreadMessagesContextType>({
  hasUnreadMessages: false,
  unreadCount: 0,
  markAsRead: () => {},
});

export const UnreadMessagesProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const unreadMessages = useUnreadMessagesHook();

  return (
    <UnreadMessagesContext.Provider value={unreadMessages}>
      {children}
    </UnreadMessagesContext.Provider>
  );
};

export const useUnreadMessages = () => useContext(UnreadMessagesContext);
